// extracted by mini-css-extract-plugin
export default {"loader":"ApiLoader_loader__zw7g4","ellipsis":"ApiLoader_ellipsis__QVk1p"};